export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE || 'es-CO'

export const concourseId = {
  DEV: {
    'es-CO': 498,
    'es-EC': 505,
    'es-AR': 518,
    'es-CL': 522,
  },
  PDN: {
    'es-CO': 558,
    'es-EC': 573,
    'es-AR': 586,
    'es-CL': 574,
  },
}[ENV || 'development'][LOCALE || 'es-CO']

export const topNumber =
  {
    'es-CO': 10,
    'es-EC': 5,
    'es-BO': 10,
    'es-PE': 10,
    'es-DO': 10,
    'es-PY': 5,
    'es-CL': 5,
    'es-AR': 10,
  }[LOCALE] || 10

// [snake,tetris,candy]
export const idsGameList = {
  DEV: {
    'es-CO': [158, 159, 160],
    'es-EC': [163, 164, 165],
    'es-AR': [176, 177, 178],
    'es-CL': [180, 181, 182],
  },
  PDN: {
    'es-CO': [165, 166, 167],
    'es-EC': [171, 172, 173],
    'es-AR': [182, 183, 184],
    'es-CL': [186, 187, 188],
  },
}[ENV || 'development'][LOCALE || 'es-CO']

export const gameId = {
  DEV: {
    'es-CO': 157,
    'es-EC': 162,
    'es-AR': 175,
    'es-CL': 179,
  },
  PDN: {
    'es-CO': 164,
    'es-EC': 169,
    'es-AR': 181,
    'es-CL': 170,
  },
}[ENV || 'DEV'][LOCALE || 'es-CO']

// const datesByCountry = {
//   'es-CO': ['31 de marzo del 2023', '31 de agosto del 2023'],
//   'es-PE': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
//   'es-AR': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
//   'es-PY': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
//   'es-CL': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
//   'es-DO': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
//   'es-PR': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
//   'es-BO': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
//   'es-EC': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
// // }
// export const activity_dates = datesByCountry[LOCALE] || datesByCountry['es-CO']

// estas fechas deben ir en este formato aaaa-mm-dd, ya que es
// la fecha como se consultan los servicios.
export const datesFaseActivities = {
  DEV: {
    'es-CO': {
      datesTopFase1: {
        startDate: '2023-03-01',
        endDate: '2023-05-31',
      },
      //Esta fecha es la que se envía en el payload del servicio a back.
      datesTopFase2: {
        startDate: '2023-03-01',
        endDate: '2023-08-31',
      },
      //Esta es la fecha que se utiliza para pintarla en el top de jugadoras fase 2.
      datesTopFase2Front: {
        startDate: '2023-06-01',
        endDate: '2023-08-31',
      },
    },
    'es-EC': {
      datesTopFase1: {
        startDate: '2023-05-15',
        endDate: '2023-07-31',
      },
      datesTopFase2: {
        startDate: '2023-08-01',
        endDate: '2023-10-15',
      },
    },
    'es-AR': {
      datesTopFase1: {
        startDate: '2023-05-15',
        endDate: '2023-08-15',
      },
      datesTopFase2: {
        startDate: '2023-08-16',
        endDate: '2023-11-30',
      },
    },
    'es-CL': {
      datesTopFase1: {
        startDate: '2023-06-15',
        endDate: '2023-08-31',
      },
      //Esta fecha es la que se envía en el payload del servicio a back.
      datesTopFase2: {
        startDate: '2023-06-15',
        endDate: '2023-11-30',
      },
      //Esta es la fecha que se utiliza para pintarla en el top de jugadoras fase 2.
      datesTopFase2Front: {
        startDate: '2023-09-01',
        endDate: '2023-11-30',
      },
    },
  },
  PDN: {
    'es-CO': {
      datesTopFase1: {
        startDate: '2023-03-01',
        endDate: '2023-05-31',
      },
      //Esta fecha es la que se envía en el payload del servicio a back.
      datesTopFase2: {
        startDate: '2023-03-01',
        endDate: '2023-08-31',
      },
      //Esta es la fecha que se utiliza para pintarla en el top de jugadoras fase 2.
      datesTopFase2Front: {
        startDate: '2023-06-01',
        endDate: '2023-08-31',
      },
    },
    'es-EC': {
      datesTopFase1: {
        startDate: '2023-05-15',
        endDate: '2023-07-31',
      },
      datesTopFase2: {
        startDate: '2023-08-01',
        endDate: '2023-10-15',
      },
    },
    'es-AR': {
      datesTopFase1: {
        startDate: '2023-05-25',
        endDate: '2023-08-01',
      },
      datesTopFase2: {
        startDate: '2023-08-02',
        endDate: '2023-11-30',
      },
    },
    'es-CL': {
      datesTopFase1: {
        startDate: '2023-06-15',
        endDate: '2023-08-31',
      },
      //Esta fecha es la que se envía en el payload del servicio a back.
      datesTopFase2: {
        startDate: '2023-06-15',
        endDate: '2023-11-30',
      },
      //Esta es la fecha que se utiliza para pintarla en el top de jugadoras fase 2.
      datesTopFase2Front: {
        startDate: '2023-09-01',
        endDate: '2023-11-30',
      },
    },
  },
}[ENV || 'development'][LOCALE || 'es-CO']

// expected to be=['31 de marzo del 2023', '31 de agosto del 2023']
export const activity_dates = {
  'es-CO': ['1 de marzo del 2023', '31 de agosto del 2023'],
  'es-AR': ['25 de mayo del 2023', '06 de diciembre del 2023'],
  'es-PE': ['1 de marzo del 2023', '31 de agosto del 2023'],
  'es-EC': ['15 de mayo del 2023', '15 de octubre del 2023'],
  'es-CL': ['15 de junio del 2023', '30 de noviembre del 2023'],
  'es-DO': ['1 de marzo del 2023', '31 de agosto del 2023'],
  'es-BO': ['1 de marzo del 2023', '31 de agosto del 2023'],
  'es-PR': ['1 de marzo del 2023', '31 de agosto del 2023'],
  'es-PY': ['1 de marzo del 2023', '31 de agosto del 2023'],
  'es-UY': ['1 de marzo del 2023', '31 de agosto del 2023'],
}[LOCALE]

export const costActivity = {
  'es-CO': 30,
  'es-AR': 20,
  'es-PE': 20,
  'es-EC': 20,
  'es-CL': 20,
  'es-DO': 20,
  'es-BO': 0,
  'es-PR': 20,
  'es-PY': 20,
  'es-UY': 0,
}[LOCALE]

export const costHelpActivity = {
  'es-CO': 10,
  'es-AR': 20,
  'es-PE': 20,
  'es-EC': 20,
  'es-CL': 20,
  'es-DO': 20,
  'es-BO': 0,
  'es-PR': 20,
  'es-PY': 20,
  'es-UY': 0,
}[LOCALE]
